import { assistantEndpoints } from '@/core/endpoints';
import { RagIndex } from '@/core/indexesEnum';
import { QuestionResponseDTO } from '@/dto/QuestionResponseDTO';
import httpService, { HttpResponse } from './HttpService';
import { RequestBuilder, doHttpRequest } from './HttpClient';
import { ServerSentEvent } from './HttpClient/ResponseParser/index';
import { Conversation } from '@/models/conversation';
import mockService from './MockService';
import { AskQuestionSectionsStreamRequestDTO } from '@/dto/AskQuestionSectionsStreamRequestDTO';
import { AskQuestionSectionsStreamResponseChunk } from '@/dto/AskQuestionSectionsStreamResponseDTO';

class LegalAssistantService {
  private mockCalls: boolean =
    process.env.VUE_APP_MOCK_CALLS === 'true' || false;

  public async askQuestion(
    question: string,
    conversation: Conversation,
    ragIndex?: RagIndex
  ): Promise<QuestionResponseDTO> {
    try {
      if (this.mockCalls) {
        const mockResponse = await mockService.returnMockQuestionResponse();

        return !ragIndex ? mockResponse : { ...mockResponse, sources: [] };
      }

      const request = !ragIndex
        ? {
            endpoint: assistantEndpoints.USER_ASSISTANT,
            request: {
              question,
              graphToken: ''
            }
          }
        : {
            endpoint: assistantEndpoints.LEGAL_ASSISTANT,
            request: {
              question,
              index: ragIndex,
              messages: conversation.messages,
              conversationId: conversation.id || null
            }
          };

      const response: HttpResponse<QuestionResponseDTO> =
        await httpService.post(request.endpoint, request.request);

      return response as unknown as QuestionResponseDTO;
    } catch (error) {
      console.error('Error in LegalAssistantService.askQuestion:', error);
      throw error;
    }
  }

  public async askQuestionSectionsStream(
    request: AskQuestionSectionsStreamRequestDTO,
    onMessage: (
      event: ServerSentEvent<AskQuestionSectionsStreamResponseChunk>
    ) => void
  ): Promise<AskQuestionSectionsStreamResponseChunk> {
    const req =
      RequestBuilder.aPostRequest<AskQuestionSectionsStreamResponseChunk>()
        .withPath(assistantEndpoints.NAW_LEGAL_ASSISTANT)
        .withJsonHeaders()
        .withJsonBody(request)
        .withServerSentEventsStreamingResponse(onMessage)
        .build();
    return await doHttpRequest(req);
  }
}

const legalAssistantService = new LegalAssistantService();
export default legalAssistantService;
